import React from 'react';

import loadHome from 'bundle-loader?lazy&title=Home!./components/home';
import loadEmail from 'bundle-loader?lazy&title=Email!./components/email';

const Bundle = ( Component ) => (
    ( props ) => (
        <Component { ...props } />
    )
);

export const routes = [ {
    title: 'Email Builder',
    pattern: '/email/:id?',
    load: loadEmail
}, {
    title: 'Email Builder',
    pattern: '/',
    load: loadHome
} ];

export const getMiddleware = () => {
    return [
        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            const { match } = nextRoute;

            if ( match && !match.render &&
                typeof match.load === 'function' ) {

                match.load( ( asyncModule ) => {
                    match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                    action.ok();
                } );
            } else {
                action.ok();
            }
        }
    ];
};

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
            action.ok();
        } );
    } else {
        action.ok();
    }
}
